import { DataBean } from "../DataBean";

export class AgreementClassification extends DataBean {
    
    


    public async getAgreementClassificationCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAgreementClassificationCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
  

}